<template>
    <div>
        <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12">
                    <el-form-item label="Descrição" prop="descricao" :rules="[$requiredBlur]">
                        <el-input v-model="dados.descricao" maxlength="120"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="4">
                    <el-form-item label="Ano letivo" prop="ano_letivo" :rules="[$requiredBlur]">
                        <el-input v-model="dados.ano_letivo" v-mask="'####'"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="4">
                    <el-form-item label="Ordem" prop="ordem" :rules="[$requiredChange]">
                        <el-select v-model="dados.ordem">
                            <el-option :label="'1º Período'" :value="1"></el-option>
                            <el-option :label="'2º Período'" :value="2"></el-option>
                            <el-option :label="'3º Período'" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="4">
                    <el-form-item label="Status" prop="status" :rules="[$requiredChange]">
                        <el-select v-model="dados.status">
                            <el-option label="Aberto" :value="1"></el-option>
                            <el-option label="Encerrado" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="6">
                    <el-form-item label="Data início (opcional)">
                        <el-input v-model="dados.data_inicio" v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-form-item label="Data fim (opcional)">
                        <el-input v-model="dados.data_fim" v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="u-mt-10">
                <el-col :xs="24" class="u-text-right">
                    <el-button type="primary" id="btn-periodo" native-type="submit">SALVAR</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ['paramId'],
    data: () => ({
        edit: false,
        dados: {
            id: '',
            descricao: '',
            ano_letivo: new Date().getFullYear(),
            ordem: 1,
            data_inicio: '',
            data_fim: '',
            status: 1
        }
    }),
    methods: {
        getById (id) {
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/periodo-diagnostico/getById/` + id, this.$store.getters.getHeaderAuth)
                .then(response => {
                    const r = response.data || {}
                    this.dados = Object.assign({}, this.dados, {
                        id: r.id,
                        descricao: r.descricao || '',
                        ano_letivo: r.ano_letivo || new Date().getFullYear(),
                        ordem: r.ordem || 1,
                        data_inicio: r.data_inicio ? this.$moment(r.data_inicio).format('DD/MM/YYYY') : '',
                        data_fim: r.data_fim ? this.$moment(r.data_fim).format('DD/MM/YYYY') : '',
                        status: r.status || 1
                    })
                }).catch((error) => { this.$store.commit('throwException', error) })
                .finally(() => { window.eventBus.$emit('loading', false) })
        },
        buildPayload () {
            const di = this.dados.data_inicio && this.$moment(this.dados.data_inicio, 'DD/MM/YYYY', true).isValid()
                ? this.$moment(this.dados.data_inicio, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
            const df = this.dados.data_fim && this.$moment(this.dados.data_fim, 'DD/MM/YYYY', true).isValid()
                ? this.$moment(this.dados.data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
            return {
                descricao: this.dados.descricao,
                ano_letivo: parseInt(this.dados.ano_letivo) || new Date().getFullYear(),
                ordem: this.dados.ordem,
                data_inicio: di,
                data_fim: df,
                status: this.dados.status
            }
        },
        onSubmit () {
            document.getElementById('btn-periodo').focus()
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const payload = this.buildPayload()
                const url = this.edit
                    ? `${this.$store.state.config.baseUrlApi}/api/periodo-diagnostico/update/` + this.dados.id
                    : `${this.$store.state.config.baseUrlApi}/api/periodo-diagnostico/store`
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth)
                    .then(response => {
                        window.eventBus.$emit('loading', false)
                        if (response.data && response.data.erro) {
                            const t = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao salvar.')
                            window.eventBus.$emit('alert', { msg: t, type: 'warning' })
                            return
                        }
                        window.eventBus.$emit('alert', { msg: 'Período salvo com sucesso.', type: 'success' })
                        this.$emit('onSubmit')
                    })
                    .catch(error => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
            })
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if (value) {
                    this.edit = true
                    this.getById(value)
                }
            }
        }
    }
}
</script>
